import React from 'react';
import { IconBase } from '../Base';
export const IconClose = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M15 5L5 15", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } }),
        React.createElement("path", { d: "M15 15L5 5", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Close.js.map